module.exports = __webpack_public_path__ + "ab57a9dea890554fce129e12a5fe9d35.png";


//////////////////
// WEBPACK FOOTER
// ./shared/images/regular-price.png
// module id = 1021
// module chunks = 2